import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function CookiesPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Política de Cookies</h1>
        
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. ¿Qué son las cookies?</h2>
            <p className="text-gray-700">
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo (ordenador, tablet o móvil) cuando visita un sitio web. Las cookies permiten que el sitio web recuerde sus acciones y preferencias durante un período de tiempo, para que no tenga que volver a configurarlas cada vez que regrese al sitio o navegue de una página a otra.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. ¿Cómo utilizamos las cookies?</h2>
            <p className="text-gray-700 mb-4">
              ASISTEC utiliza cookies para mejorar la experiencia del usuario en nuestro sitio web. Las cookies nos ayudan a:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Recordar sus preferencias y configuraciones</li>
              <li>Entender cómo utiliza nuestro sitio web</li>
              <li>Mejorar el rendimiento y funcionalidad del sitio</li>
              <li>Proporcionar contenido relevante</li>
              <li>Analizar el tráfico y comportamiento de los usuarios</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Tipos de cookies que utilizamos</h2>
            
            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.1. Cookies técnicas (necesarias)</h3>
              <p className="text-gray-700">
                Son esenciales para el funcionamiento del sitio web. Sin estas cookies, el sitio web no puede funcionar correctamente. Estas cookies no recopilan información sobre usted que pueda ser utilizada con fines de marketing o para recordar dónde ha estado en Internet.
              </p>
            </div>

            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.2. Cookies de rendimiento</h3>
              <p className="text-gray-700">
                Estas cookies recopilan información sobre cómo los visitantes utilizan el sitio web, por ejemplo, qué páginas visitan con más frecuencia. Toda la información que recopilan estas cookies es agregada y, por lo tanto, anónima. Solo se utiliza para mejorar el funcionamiento del sitio web.
              </p>
            </div>

            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.3. Cookies de funcionalidad</h3>
              <p className="text-gray-700">
                Estas cookies permiten que el sitio web recuerde las elecciones que hace (como su nombre de usuario, idioma o región) y proporcionan características mejoradas y más personales.
              </p>
            </div>

            <div className="mb-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.4. Cookies de terceros</h3>
              <p className="text-gray-700">
                En algunos casos, utilizamos cookies proporcionadas por terceros de confianza. Estas cookies pueden incluir servicios de análisis web como Google Analytics, que nos ayudan a entender cómo los usuarios interactúan con nuestro sitio.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Cookies específicas utilizadas</h2>
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-300 text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Cookie</th>
                    <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Tipo</th>
                    <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Duración</th>
                    <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Propósito</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">session_id</td>
                    <td className="border border-gray-300 px-4 py-2">Técnica</td>
                    <td className="border border-gray-300 px-4 py-2">Sesión</td>
                    <td className="border border-gray-300 px-4 py-2">Mantener la sesión del usuario</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">cookie_consent</td>
                    <td className="border border-gray-300 px-4 py-2">Técnica</td>
                    <td className="border border-gray-300 px-4 py-2">1 año</td>
                    <td className="border border-gray-300 px-4 py-2">Recordar preferencias de cookies</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">_ga</td>
                    <td className="border border-gray-300 px-4 py-2">Analítica</td>
                    <td className="border border-gray-300 px-4 py-2">2 años</td>
                    <td className="border border-gray-300 px-4 py-2">Google Analytics - Distinguir usuarios</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">_gid</td>
                    <td className="border border-gray-300 px-4 py-2">Analítica</td>
                    <td className="border border-gray-300 px-4 py-2">24 horas</td>
                    <td className="border border-gray-300 px-4 py-2">Google Analytics - Distinguir usuarios</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. ¿Cómo controlar las cookies?</h2>
            <p className="text-gray-700 mb-4">
              Puede controlar y/o eliminar las cookies como desee. Puede eliminar todas las cookies que ya están en su dispositivo y puede configurar la mayoría de los navegadores para evitar que se coloquen. Sin embargo, si hace esto, es posible que tenga que ajustar manualmente algunas preferencias cada vez que visite un sitio y que algunos servicios y funcionalidades no funcionen.
            </p>
            <p className="text-gray-700 mb-4">
              Para gestionar las cookies en los navegadores más comunes:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Google Chrome:</strong> Configuración &gt; Privacidad y seguridad &gt; Cookies</li>
              <li><strong>Mozilla Firefox:</strong> Opciones &gt; Privacidad y seguridad &gt; Cookies</li>
              <li><strong>Safari:</strong> Preferencias &gt; Privacidad &gt; Cookies</li>
              <li><strong>Microsoft Edge:</strong> Configuración &gt; Privacidad &gt; Cookies</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Cookies de terceros</h2>
            <p className="text-gray-700">
              En algunos casos especiales, también utilizamos cookies proporcionadas por terceros de confianza. Estas cookies pueden incluir servicios de análisis web, redes sociales o servicios de mapas. Cada uno de estos servicios tiene su propia política de privacidad y cookies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Consentimiento</h2>
            <p className="text-gray-700">
              Al utilizar nuestro sitio web, usted acepta el uso de cookies de acuerdo con esta Política de Cookies. Si no está de acuerdo con el uso de cookies, puede deshabilitarlas en la configuración de su navegador, aunque esto puede afectar la funcionalidad del sitio web.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Actualizaciones de esta política</h2>
            <p className="text-gray-700">
              Podemos actualizar esta Política de Cookies ocasionalmente para reflejar cambios en las cookies que utilizamos o por otras razones operativas, legales o reglamentarias. Le recomendamos que revise esta página periódicamente para estar informado sobre nuestro uso de cookies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Más información</h2>
            <p className="text-gray-700 mb-4">
              Si tiene alguna pregunta sobre nuestra Política de Cookies, puede contactarnos:
            </p>
            <ul className="list-none text-gray-700 space-y-2">
              <li><strong>Email:</strong> correodeasistecsl@gmail.com</li>
              <li><strong>Teléfono:</strong> 628 752 701</li>
              <li><strong>WhatsApp:</strong> 628 752 701</li>
            </ul>
          </section>

          <p className="text-gray-600 text-sm mt-12">
            Última actualización: Enero 2025
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}
